import { Box, Stack, Skeleton } from '@mui/material'
import BreadCrumbs from '../../../components/BreadCrumbs'
import {  useState, useEffect } from 'react'
import { useDispatch, } from 'react-redux'
import HeadlineTitle from '../../../components/HeadlineTitle';
import CardPreferred from './components/CardPreferred';
import ButtonCreate from '../../../components/ButtonCreate';
import DialogCreation from './components/DialogCreation';
import { RootState } from '../../../app/store';
import { useSelector } from 'react-redux';
import { getPreferredListsData, getPreferredListsDataLoadMore, getSearchCompanyByCode } from './redux/buyerListsReducer';
import LoaderBackdrop from '../../../components/LoaderBackdrop';
import InfiniteScroll from 'react-infinite-scroll-component';
import swal from 'sweetalert';
import LoaderProgress from '../../../components/LoaderProgress';
import EmptyData from '../../../components/EmptyData';
import Button from '@mui/material/Button';
import { resetSnackBarPreferred } from './redux/buyerListsSlice';
import SnackBarAlert from '../../../components/SnackBarAlert';
import SearchComponent from '../../../components/SearchComponent';
import { checkValidation } from '../../../utilities/userFeaturesValidation';


function BuyerLists() {

    const { 
        data, total_data, loading, loading_search, search_buyer, 
        loading_create, loading_update,
        create, update, loading_bulk_upload, bulk_upload
    } = useSelector((state : RootState) => state.preferred)

    const dispatch = useDispatch()

    const [valueSearchCompany, setValueSearchCompany] = useState("");
    const [valueSearch, setValueSearch] = useState<any>("");

    const [limit,setSkip ] = useState(10);
    const [skip, ] = useState(0);
    const [dataInfinite, setDataInfinite] = useState<any>([]);
    const [hasMore,setHasMore] = useState(true);

    const [dialogCreation, setDialogCreation] = useState(false);
    const [dialogName, setDialogName] = useState("");

    const fetchMoreData = async () => {
        const params = {
            limit,
            skip : skip + 1,
            search : valueSearch,
        }
         
        const newdata : any = await dispatch(getPreferredListsDataLoadMore(params))
        if(newdata.type === "'preferred-lists-loadmore/get/fulfilled"){
            setSkip(skip + 1)
            let array = [...dataInfinite, ...newdata.payload.data]
            if(newdata.payload.data.length === 0){
                setHasMore(false)
            } else {
                setHasMore(true)
                setDataInfinite(array)
            }
        } else {
            swal("Error", newdata.payload.message, "error")
        }
    };

    useEffect(() => {
        setDataInfinite(data)
        if(data.length >= total_data) {
            setHasMore(false)
        }
        // eslint-disable-next-line
    }, [data, total_data]);


    const scrollToTop = () => {
        // @ts-ignore
        document.getElementById("scrollableDivPreferred").scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        const params = {
            limit, 
            skip : 0,
            search : valueSearch,
        }
        dispatch(getPreferredListsData(params))
        // eslint-disable-next-line
    }, [valueSearch]);
    
    useEffect(() => {
        const search = {
            limit : 10,
            skip : 0,
            'filterTopic[]' : ['code'],
            'filterValue[]' : [valueSearchCompany]   
        }
        if(valueSearchCompany !== "" && valueSearchCompany !== undefined) {
            dispatch(getSearchCompanyByCode(search))
        }
        // eslint-disable-next-line
    }, [valueSearchCompany]);

    useEffect(() => {
        if(create || update || bulk_upload) {
            const params = {
                limit,
                skip : 0,
                search : valueSearch,
            }
            setTimeout(() => {
                dispatch(getPreferredListsData(params))
                dispatch(resetSnackBarPreferred())
            }, 2500);
        }
        // eslint-disable-next-line
    }, [create, update, bulk_upload]);

    return (
        <Box m={2}>
            <LoaderBackdrop loading={loading_create || loading_update || loading_bulk_upload } />
            <BreadCrumbs 
                isPage={false}
                current="Preferred Buyer List"
            />
            <Stack direction="row" justifyContent="space-between" alignItems="center" my={1} flexWrap="wrap">
                <Box>
                    <HeadlineTitle 
                        title='Preferred Buyer List'
                        variant="h6"
                        bold="bold"
                    />
                </Box>
                { checkValidation('CREPREBUY883630') &&
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <ButtonCreate 
                        name="Add New Buyer"
                        onClick={() => {
                            setDialogName("Add New Buyer")
                            setDialogCreation(true)
                        }}
                    />
                </Stack> }
            </Stack>

            <SearchComponent 
                valueSearch={valueSearch}
                setValueSearch={setValueSearch}
                placeholder="Search by name or company code.."
            />

            { loading ?
            <Stack mt={1} className="item-card-preferred">
                {[1,2,3].map(idx => (
                    <Box key={idx} my={0.5}>
                        <Skeleton variant="rectangular" width={"100%"} height={250} sx={{borderRadius:2}} />
                    </Box>
                ))}
            </Stack>
            :
            <div id="scrollableDivPreferred"  className="overhiddenflow">
                { dataInfinite.length > 0 ? 
                <div>
                    <InfiniteScroll
                        dataLength={dataInfinite.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        loader={<LoaderProgress/>}
                        scrollableTarget="scrollableDivFulfillment"
                        endMessage={
                            <Stack flexDirection="column" justifyContent="center" alignItems="center" mt={3} mb={5}>
                                <Box>
                                    <HeadlineTitle title="No more data found." variant="body2" bold='400' />
                                </Box>
                                <Box>
                                    <Button onClick={() => scrollToTop()} size="small" variant='contained'>
                                        <p>Back to Top</p>
                                    </Button>
                                </Box> 
                            </Stack>
                        }
                    >
                    <Box>
                        {dataInfinite.map((item:any, idx:number) => (
                            <Box key={idx}>
                                <CardPreferred item={item} />
                            </Box>
                        ))}
                    </Box>
                    </InfiniteScroll>
                </div> :
                <Box mt={2} mx={0.2}>
                    <EmptyData 
                        message="Preferred is not found." 
                        caption="Try to change your search or filter."
                    />
                </Box> }
            </div> }
            
            <DialogCreation  
                open={dialogCreation} 
                setOpen={setDialogCreation} 
                name={dialogName} 
                valueSearch={valueSearchCompany}
                setValueSearch={setValueSearchCompany}
                search_buyer={search_buyer}
                loading_search={loading_search}
            />
            <SnackBarAlert message={`Preferred Buyer is successfuly added`} initialState={create} />
            <SnackBarAlert message={`Preferred Buyer is successfuly updated`} initialState={update} />
        </Box>
    )
}

export default BuyerLists

